export var postMessageType = "themeChange";
export var sendThemeChangedPostMessage = function sendThemeChangedPostMessage(windowForPostMessage, theme, domain) {
  if (typeof windowForPostMessage.postMessage === "undefined") return;
  windowForPostMessage.postMessage({
    type: postMessageType,
    value: theme
  }, domain || "*");
};
//# sourceMappingURL=theme.js.map